const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const sections = Array.from(document.querySelectorAll('.shopify-section'));

if (isSafari()) {
  document.documentElement.classList.add('is-safari');
}

if (reduceMotion || sections.length === 0) {
  revealAll();
} else {
  sections.forEach((section) => section.setAttribute('data-stretch-reveal', ''));

  const pageWrapper = document.querySelector('.page-wrapper');
  const scrollRoot = pageWrapper instanceof HTMLElement ? pageWrapper : null;
  const root = getScrollRoot();
  let rafId = 0;

  const updateVisibleSections = () => {
    rafId = 0;

    for (const section of sections) {
      if (section.classList.contains('is-visible')) continue;
      if (isInRevealRange(section, getScrollRoot())) {
        section.classList.add('is-visible');
      }
    }

    if (sections.every((section) => section.classList.contains('is-visible'))) {
      root?.removeEventListener('scroll', scheduleUpdate);
      scrollRoot?.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
    }
  };

  function scheduleUpdate() {
    if (rafId) return;
    rafId = requestAnimationFrame(updateVisibleSections);
  }

  root?.addEventListener('scroll', scheduleUpdate, { passive: true });
  scrollRoot?.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries, sectionObserver) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-visible');
          sectionObserver.unobserve(entry.target);
        }
      },
      { root, rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
    );

    sections.forEach((section) => observer.observe(section));
  }

  scheduleUpdate();
}

function revealAll() {
  sections.forEach((section) => section.classList.add('is-visible'));
}

function getScrollRoot() {
  const pageWrapper = document.querySelector('.page-wrapper');
  if (!(pageWrapper instanceof HTMLElement)) return null;

  const styles = getComputedStyle(pageWrapper);
  const scrollable = /(auto|scroll)/.test(styles.overflowY) && pageWrapper.scrollHeight > pageWrapper.clientHeight;

  return scrollable ? pageWrapper : null;
}

/**
 * IntersectionObserver can lag inside Safari's overflow scroller. This geometry
 * check is intentionally small and deterministic so visible sections never stay hidden.
 * @param {Element} section
 * @param {Element | null} root
 */
function isInRevealRange(section, root) {
  const rect = section.getBoundingClientRect();
  const rootRect = root?.getBoundingClientRect();
  const viewportTop = rootRect?.top ?? 0;
  const viewportBottom = rootRect?.bottom ?? window.innerHeight;
  const revealOffset = (viewportBottom - viewportTop) * 0.08;

  return rect.top < viewportBottom - revealOffset && rect.bottom > viewportTop;
}

function isSafari() {
  return /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(navigator.userAgent);
}
